import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';

export const appRoutes: Route[] = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.routes'),
    title: _('Dev.Navigation.Home.Title'),
  },
  {
    path: 'api',
    loadChildren: () => import('./api/api.routes'),
    title: _('Dev.Navigation.Api.Title'),
  },
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/authentication.routes'),
    title: _('Dev.Navigation.Authentication.Title'),
  },
  {
    path: 'error/:code',
    loadComponent: () => import('@mds/ngx-layout').then((m) => m.ErrorPageComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
